import React, { forwardRef } from "react";
import styled from "@emotion/styled";
import { StyledButton } from "../../HeaderStyles";
import PreviewIcon from "src/icons/PreviewIcon";
import PhoneRingingIcon from "src/icons/PhoneRingingIcon";
import NotificationDotIcon from "src/icons/NotificationDotIcon";
import { usePreviewButton } from "./PreviewButton.hook";
import { PREVIEW_BUTTON_TEXT } from "./PreviewButton.consts";
import Tooltip from "@hyro-components/Tooltip";
import { CircularProgress, useTheme } from "@mui/material";

const IconWrapper = styled("span")`
  position: absolute;
  top: -7px;
  right: -7px;
`;

const PreviewButton = forwardRef(({ handleOpenDropdown, openPreparePreviewDialog }, ref) => {
  const { palette } = useTheme();
  const {
    isPreviewDisabled,
    isLoadingPreview,
    isPhone,
    isBuilding,
    isPreparingPreview,
    shouldPreparePreview,
    handlePreviewClick,
    getTooltipText
  } = usePreviewButton();

  const buttonIcon = () => {
    if (isLoadingPreview) {
      return null;
    }

    if (isBuilding) {
      return <CircularProgress size={16} sx={{ color: "grey.400" }} data-testid="preview-button-loading-icon" />;
    }

    return isPhone ?
      <PhoneRingingIcon size={20} disabled={isPreviewDisabled} testId="preview-button-phone-icon" /> :
      <PreviewIcon size={20} disabled={isPreviewDisabled} testId="preview-button-web-icon" />;
  };

  return (
    <Tooltip tooltipStyle={{ whiteSpace: "pre-line" }} title={getTooltipText()} testId="preview-button">
      <StyledButton
        ref={ref}
        data-testid={isPhone ? "page-preview-voice-button" : "page-preview-web-button"}
        disabled={isPreviewDisabled || isBuilding}
        loading={isLoadingPreview}
        variant="outlined"
        startIcon={buttonIcon()}
        onClick={(e) => handlePreviewClick(e, handleOpenDropdown, openPreparePreviewDialog)}
      >
        {isPreparingPreview ? PREVIEW_BUTTON_TEXT.PREPARING_PREVIEW : PREVIEW_BUTTON_TEXT.PREVIEW}
        {shouldPreparePreview && <IconWrapper><NotificationDotIcon color={palette.warning[500]} /></IconWrapper>}
      </StyledButton>
    </Tooltip >
  );
});

PreviewButton.displayName = "PreviewButton";

export default PreviewButton;
